export default function makeGetTableWidth(store) {
  return {
    getTableWidth: function getTableWidth(editor, tableId) {
      var _ref = store.getItem(tableId) || {},
          resizingColumn = _ref.resizingColumn,
          resizingColumnWidth = _ref.resizingColumnWidth;

      return editor.getTableRowCells(tableId, 0).reduce(function (width, cell, index) {
        return width + (resizingColumn === index ? resizingColumnWidth : cell.getIn(['data', 'width']) || 200);
      }, 0);
    }
  };
}